/*
this helper is used to direct user to different page after user login
it might direct users to the following pages:
(1) main page
(2) TC page
(3) register page
    (a) prefill the school name 
    (b) school name changable
(4) revoke the request page
(5) invitation expired alert page
(6) email verification page
(7) user pending to delete page
*/

import checkAccountValidity from "./getAccountStatus";

export default function userLoadingPageHelper(user, account) {
  const directPaths = {
    toMainPage: false,
    toTCPage: false,
    toEmailVerificationPage: false,
    toRegisterPage: false,
    toRevokeRequestPage: false,
    toInvitationExpiredPage: false,
    toPendingToDeletePage: false,
    toRequestToJoinPage: false,
    toAccountNotActivePage: false,
    toResetPswdPage: false,
    alert_type: null,
  };

  if (!user || !user.id) {
    return directPaths;
  }

  if (user.resetPswd) {
    directPaths.toResetPswdPage = true;
    return directPaths;
  }

  if (user?.authInfo?.email_verified) {
    //if user is verified
    if (user.pendingToDelete) {
      directPaths.toPendingToDeletePage = true;
    } else {
      if (user.isSuperAdmin) {
        //if user is super admin
        if (user.termsAcceptedOn) {
          //if SA accepted the terms and conditions
          directPaths.toMainPage = true;
        } else {
          //if SA not accepted the terms and conditions
          directPaths.toTCPage = true;
        }
      } else {
        //if user is not super admin
        if (Object.keys(user.UserRoles).length > 0) {
          //if the user has userrole in any account
          if (user.requestToJoin) {
            directPaths.toRevokeRequestPage = true;
            directPaths.alert_type = "OPEN_JOIN_REQUEST";
          } else {
            if (user.invitationExpired) {
              directPaths.toInvitationExpiredPage = true;
              directPaths.alert_type = "INVITE_EXPIRED_CONTACT_US";
            } else {
              if (
                user.invitationToken === "accepted" ||
                user.invitationToken === null
              ) {
                if (user.termsAcceptedOn) {
                  const {
                    isPendingToDelete,
                    isTrialValid,
                    isSubscriptionValid,
                  } = checkAccountValidity(account);
                  if (
                    isPendingToDelete ||
                    (!isTrialValid && !isSubscriptionValid)
                  ) {
                    directPaths.toAccountNotActivePage = true;
                    directPaths.alert_type = "ACCOUNT_INACTIVE";
                  } else {
                    directPaths.toMainPage = true;
                  }
                } else {
                  directPaths.toTCPage = true;
                }
              } else {
                directPaths.toRegisterPage = true;
              }
            }
          }
        } else {
          //if the user has no userrole in any account
          if (account) {
            const { isPendingToDelete, isTrialValid, isSubscriptionValid } =
              checkAccountValidity(account);
            if (isPendingToDelete) {
              directPaths.toAccountNotActivePage = true;
            } else if (isSubscriptionValid) {
              //if the account is active paid account, go to request to join page
              directPaths.toRequestToJoinPage = true;
            } else if (isTrialValid) {
              //if the account is active trial account, do nothing since we assigned the user to the accoutn during registraiton already
              console.log("user is in trial account");
            } else {
              //if the account is not active paid or active trial, go to register page
              directPaths.toAccountNotActivePage = true;
            }
          } else {
            directPaths.toRegisterPage = true;
          }
        }
      }
    }
  } else {
    //if user not verified, direct to email verification page
    directPaths.toEmailVerificationPage = true;
    directPaths.alert_type = "EMAIL_VERIFICATION_PENDING";
  }

  return directPaths;
}
